import * as React from 'react';
import { Control, FieldValues, useController, useForm, useFormContext, useWatch } from 'react-hook-form';

interface UseEditableControllersProps<TFieldValues extends FieldValues> {
  fieldNames: string[],
  control?: Control<TFieldValues>,
}
function useEditableControllers<TFieldValues extends FieldValues>({
  fieldNames,
  control,
}: UseEditableControllersProps<TFieldValues>) {
  const watchedValues = useWatch({ control, name: fieldNames as any[] });

  const { formState, resetField, reset, getValues, handleSubmit } = useFormContext();

  const commit = () => {
    handleSubmit(() => {});
    // fieldNames.forEach((fieldName, index) => {
    //   resetField(fieldName, {
    //     defaultValue: watchedValues[index],
    //     keepDirty: false,
    //     keepError: false,
    //     keepTouched: false,
    //   });
    // });
  };

  const revert = () => {
    let values = getValues();
    // reset(formState.defaultValues); // potential fix but it causes entire form to reset

    fieldNames.forEach((fieldName) => {
      values = { ...values, [fieldName]: formState.defaultValues?.[`${fieldName}`] };
    });

    reset(values);
  };

  return {
    watchedValues,
    commit,
    revert,
    formState,
  };
}

export default useEditableControllers;
